import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  rightSide: {
    minWidth: 175
  },
  safetySelect: {
    // reset .stepBody .field, margin-top: 16px
    marginTop: ['unset', '!important']
  },
  excludeUnrateableUrlsCheckbox: {
    marginLeft: ['unset', '!important']
  }
})

export default useStyles
